import { Sky } from "@react-three/drei";

const Environment = () => {
  return (
    <>
      <Sky sunPosition={[1, 2, 3]} />
    </>
  );
};

export default Environment;
